module.exports = __webpack_public_path__ + "static/media/arrow-down.0328e15e.svg";